module.exports = ".comfirmButton-dialog {\n  margin-right: 35px; }\n"